import * as React from "react";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { useRouter } from "next/navigation";
import { UserContext } from "@/src/Contexts/UserContext";
import { signOutUser } from "@/src/Firebase/firebase.utils";
import { translatedVariants } from "@/src/Utils/translationObject";

export default function NavbarUserMenu({
  id,
  handleOpenModal,
}: {
  id: string;
  handleOpenModal: () => void;
}) {
  const { user } = React.useContext(UserContext);
  if (!id) {
    id = "en";
  }
  const router = useRouter();
  const handleClickHelp = () => {
    window.open("https://google.com", "_blank");
  };

  const handleSignout = async () => {
    await signOutUser();
    router.push("/login");
  };

  const handleMyAccount = () => {
    router.push("/user/my-account");
  };

  const handleAdminArea = () => {
    router.push("/admin/dashboard");
  };

  return (
    <Paper sx={{ width: 250, maxWidth: "100%", borderRadius: "20px" }}>
      <MenuList>
        {user.id === "" && (
          <>
            <MenuItem>
              <ListItemText onClick={() => router.push("/signup")}>
                {id === ""
                  ? "Sign Up"
                  : translatedVariants[id as keyof typeof translatedVariants]
                      .signup}
              </ListItemText>
            </MenuItem>
            <MenuItem>
              <ListItemText onClick={() => router.push("/login")}>
                {id === ""
                  ? "Log In"
                  : translatedVariants[id as keyof typeof translatedVariants]
                      .login}
              </ListItemText>
            </MenuItem>
          </>
        )}
        {user.id !== "" && user.type === "admin" && (
          <MenuItem>
            <ListItemText onClick={handleAdminArea}>
              {id === ""
                ? "Admin Area"
                : translatedVariants[id as keyof typeof translatedVariants]
                    .admin_area}
            </ListItemText>
          </MenuItem>
        )}
        {user.id !== "" && (
          <>
            <MenuItem>
              <ListItemText onClick={handleMyAccount}>
                {id === ""
                  ? "My Account"
                  : translatedVariants[id as keyof typeof translatedVariants]
                      .my_account}
              </ListItemText>
            </MenuItem>
            <MenuItem className={"verifyMenuLink"}>
              <ListItemText onClick={handleOpenModal}>
                {
                  translatedVariants[id as keyof typeof translatedVariants]
                    .verification
                }
              </ListItemText>
            </MenuItem>
            <MenuItem>
              <ListItemText onClick={handleSignout}>
                {id === ""
                  ? "Sign Out"
                  : translatedVariants[id as keyof typeof translatedVariants]
                      .logout}
              </ListItemText>
            </MenuItem>
          </>
        )}
        <Divider />
        <MenuItem>
          <ListItemText onClick={handleClickHelp}>
            {id === ""
              ? "Help"
              : translatedVariants[id as keyof typeof translatedVariants].help}
          </ListItemText>
        </MenuItem>
      </MenuList>
    </Paper>
  );
}
